// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2u8R5","file":"styles_file__DDIi_"};